import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { author as AuthorPropType } from 'lib/CustomPropTypes';
import { generateElementKey } from 'lib/stringUtils';
import Link from 'components/Link';

function Byline({ authors }) {
  if (!Array.isArray(authors) || authors.length === 0) {
    return null;
  }

  const children = [];
  authors.forEach((author) => {
    const name = get(author, ['person', 'name']);
    if (typeof name === 'string') {
      const key = generateElementKey(name);
      const url = get(author, ['person', 'url', 'primary']);
      if (url) {
        children.push((
          <Link key={key} to={url}>
            {name.trim()}
          </Link>
        ));
      } else {
        children.push((
          <span key={key}>
            {name.trim()}
          </span>
        ));
      }
    }
  });

  return (
    <>
      {children}
    </>
  );
}

Byline.propTypes = {
  authors: PropTypes.arrayOf(
    AuthorPropType,
  ),
};

Byline.defaultProps = {
  authors: null,
};

export { Byline };
